// import { useState } from "react";
import { Data } from "../Data/data";
const Skills = () => {
    const data = Data.Skills;
    // const [data, setData] = useState(Data.Skills);
    


    return ( 
        <section id="skills" className="h-100">
            <div>
                <h1 className="text-3xl font-bold pb-4 flex justify-center font-russo">My Skillset Includes</h1>
                <div className="px-4">

                    <div className="flex justify-center py-4"  data-aos="zoom-in-right">
                        <img src="/assets/html.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse" />
                        <img src="/assets/css.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/javascript(1).svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/typescript.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/tailwind-css.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/visualstudio.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/firebase.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                    </div>


                    <div className="flex justify-center py-4"  data-aos="zoom-in-left">
                    <img src="/assets/bootstrap.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/python.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/django.svg" alt="" className="h-20 w-20 px- min-w-0 animate-pulse"/>
                        <img src="/assets/flask.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/react.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-spin"/>
                        <img src="/assets/wordpress.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/figma.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>

                    </div>

                    <div className="flex justify-center py-4"  data-aos="fade-up">
                        <img src="/assets/github.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/jquery.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                        <img src="/assets/nextjs-icon.svg" alt="" className="h-20 w-20 px-2 min-w-0 animate-pulse"/>
                    </div>

                </div>
                <div className="grid grid-cols-2 px-10">
                    {/* <div>
                        <h1>Responsive Web Design</h1>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas alias tempora eum neque quibusdam ducimus cumque!</p>
                    </div>
                    <div>
                        <img src="" alt="" />
                    </div>
                    <div>
                        <img src="" alt="" />
                    </div>
                    <div>
                        <h1>Responsive Web Design</h1>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas alias tempora eum neque quibusdam ducimus cumque!</p>
                    </div>
                    <div>
                        <h1>Responsive Web Design</h1>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas alias tempora eum neque quibusdam ducimus cumque!</p>
                    </div>
                    <div>
                        <img src="" alt="" />
                    </div>
                    <div>
                        <img src="" alt="" />
                    </div>
                    <div>
                        <h1>Responsive Web Design</h1>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas alias tempora eum neque quibusdam ducimus cumque!</p>
                    </div> */}

                    
                        {data && data.map(skill => {
                            return(
                                <div key={skill.id} className="col-span-2 md:col-span-1 md:px-5 font-rubik py-10" data-aos={skill.id % 2 === 0 ? 'fade-down' : 'fade-up'}>
                                    <h1 className="text-4xl font-russo">{skill.h1}</h1>
                                    <p className="text-lg md:text-xl">{skill.p}</p>
                                </div>
                            )
                            
                        })}
                    
                </div>
            </div>
        </section>
     );
}
 
export default Skills;